import React, { useState, useEffect } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import { extend } from '@thd-nucleus/data-sources';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import { OnlineDoor } from './online-door/OnlineDoor';
import styles from './virtual-consulting.module.scss';

let cx = classNames.bind(styles);

export const VirtualConsulting = (props) => {
  const { itemId } = props;
  const { mvaTestB } = useLayoutGroupProps({ props });
  const [mvaTestA, setMvaTestA] = useState(false);
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('virtual-consulting.ready');
    LIFE_CYCLE_EVENT_BUS.lifeCycle.on('virtual-assistance.mvaTestA', (data) => {
      setMvaTestA(data.output.mvaTestA);
    });
  }, []);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('virtual-consulting.mvaTestB', { mvaTestB });
  }, [mvaTestB]);

  if (!itemId || mvaTestA) return null;

  return (

    <div id="mva-banner" className={cx('virtual-consulting')}>
      <OnlineDoor itemId={itemId} />
    </div>

  );
};

VirtualConsulting.displayName = 'VirtualConsulting';

VirtualConsulting.propTypes = {
  itemId: string.isRequired
};

VirtualConsulting.dataModel = extend(OnlineDoor);